<template>
  <div o-Container o-Container-App>
    <div id="tb_Username">
      <input v-model="octopus.passport.name" clearable placeholder="请输入用户名" AUTOCOMPLETE="off"/>
    </div>
    <div id="tb_Password">
      <input v-model="octopus.passport.password" type="password" clearable placeholder="请输入密码"/>
    </div>
    <div id="tb_Button" @click="login">登录</div>

    <!-- <div id="tb_Register" @click="register">还没账号？注册</div>
    <div id="tb_agreement" style="position:fixed;bottom: 15px;left: 15px;line-height: 30px;color: white;font-size: 12px;text-align: center;">
      <span>注册即同意</span>
      <span class="green" style="color: #008FFF;" @click="getAgreement">《GDSmart用户协议》</span>
      <span>和</span>
      <span class="green" style="color: #008FFF;" @click="getPrivacy">《GDSmart隐私政策》</span>
    </div> -->
  </div>

</template>

<script>
  export default {
    name: "app_en_database_item", /* 这个name暂时不知道用啥用，根据官方文档说的是方便排错的 */
    data() {
      return {
        octopus: this.$parent.octopus,
      }
    },
    activated: function () {
      // console.log('app login');
      //初始化拿到数据
      this.query = this.$route.query;
      document.documentElement.scrollTop = 0;

      this.octopus.tools.isApplet().then(res => {
        if (res) {
          console.log('app login', res);
          this.$router.push({
            path: '/admin/loginApplet',
            query: this.$route.query
          })
        } else {
          // 如果不是移动端，则跳转到web
          if (!this.octopus.tools.isMobile()) {
            this.octopus.router.jump("/admin/login");
          }
        }
      })

      this.octopus.tips.debug("Login.vue执行了activated事件。");
    },
    mounted:function(){
      // this.octopus.confirm.success("开始同步之前，请务必确认双方表结构一致。", function (status) {
      //   // 点击确认后的事件
      //   alert(status);
      // });
    },
    methods: {
      //隐私
      getPrivacy() {
        //利用try容错
        try {
          // 登陆成功，告知移动端传递函数
          if (window.webkit) {
            window.webkit.messageHandlers.setLogin.postMessage(false);
          } else if (window.Android) {
            window.setLogin.setLogin();
          }
        } catch (e) {
        }
        this.octopus.router.jump("/APP/Main/Privacy/Page");
      },
      //协议
      getAgreement() {
        //利用try容错
        try {
          // 登陆成功，告知移动端传递函数
          if (window.webkit) {
            window.webkit.messageHandlers.setLogin.postMessage(false);
          } else if (window.Android) {
            window.setLogin.setLogin();
          }
        } catch (e) {
        }
        this.octopus.router.jump("/APP/Main/Agreement/Page");
      },
      //register 交互
      register: function () {
        try {
          // 登陆成功，告知移动端传递函数
          if (window.webkit) {
            window.webkit.messageHandlers.setLogin.postMessage(false);
          } else if (window.Android) {
            window.setLogin.setLogin();
          }
        } catch (e) {
        }
        //返回注册
        this.octopus.router.jump("/APP/Main/Register/Page");

      },
      // 登录前置审核
      login: function () {
        // 提交的时候判断是否是已经加密，如果没有，则提交登录的时候对数据进行加密。
        if (!this.octopus.passport.encryption) {
          // 更新时间戳（毫秒）
          this.octopus.passport.timespan = (new Date()).valueOf();
          this.octopus.passport.password = this.octopus.tools.md5(this.octopus.passport.name
            + "marco" + this.octopus.passport.timespan + "july" + this.octopus.passport.password);
        }

        // 触发登录函数
        this.auto();
      },
      auto: function () {
        let o = this;
        // 获取护照数据，不管成功与否，全部设置为true。
        this.octopus.request.security.passport.get(function (passport_data) {
          o.octopus.passport.encryption = true;
          if (!o.octopus.tools.IsNullOrEmpty(passport_data) && passport_data.status.code == 200) {
            o.octopus.request.security.token.get(function (token_data) {
              if (!o.octopus.tools.IsNullOrEmpty(token_data) && token_data.status.code == 200) {
                //
                let userMD5 = o.octopus.tools.md5(o.octopus.passport.id.toString());
                let userName = o.octopus.passport.realName;
                try {
                  // 登陆成功，告知移动端传递函数
                  if (window.webkit) {
                    window.webkit.messageHandlers.setLogin.postMessage(false);
                    // if (window.webkit) {
                    window.webkit.messageHandlers.setUserID.postMessage(userMD5);
                    window.webkit.messageHandlers.setUserName.postMessage(userName);
                    // }
                  } else if (window.Android) {
                    window.setUserID.setUserID(userMD5)
                    window.setLogin.setLogin();
                    window.setUserName.setUserName(userName);
                  }
                } catch (e) {
                }


                // 调试时打印获取到权限数据。
                o.octopus.tips.debug("Login页面Auto更新护照：" + JSON.stringify(passport_data));
                // 执行跳转系统内页
                o.octopus.router.jump("/APP/Main/Home/Page");
              } else {
                o.octopus.tips.error(token_data);
              }
            });
          } else {
            o.octopus.tips.error(passport_data);
          }
        });
      },
    },
    props: ["oData"]
  }
</script>



// WEBPACK FOOTER //
// src/components/APP/Main/Login/Page.vue